export const ITEM_DEPTHS = [
    { key: 'any_item_depth', label: 'Any Item Depth' },
    { key: 'gte_10', label: 'More than 10' },
    { key: 'gte_20', label: 'More than 20' },
    { key: 'gte_50', label: 'More than 50' },
    { key: 'gte_100', label: 'More than 100' },
    { key: 'gte_300', label: 'More than 300' },
    { key: 'gte_500', label: 'More than 500' },
];
